import React from "react";
import PropTypes from "prop-types";

import DateFormatingService from "services/DateFormatingService";

const VideoSectionPlaylist = ({ playlist, handleVideoClick, activeVideo }) => (
  <div className="video-section__playlist">
    {playlist.videos.map((video, index) => (
      <button
        className={`card is-list ${activeVideo === index ? "is-active" : ""}`}
        type="button"
        onClick={() => {
          handleVideoClick(index);
        }}
        key={index}
      >
        <div className="card__image">
          <img src={video.image} alt="" />
        </div>
        <div className="card__content">
          <h3 className="card__title">{video.title}</h3>
          <div className="card__meta">
            <span className="card__main main-tag">{video.program}</span>
            <span className="card__date date">
              {DateFormatingService.formatToTimeAndDate(video.date * 1000)}
            </span>
          </div>
        </div>
      </button>
    ))}
  </div>
);

VideoSectionPlaylist.propTypes = {
  playlist: PropTypes.shape({}).isRequired,
  handleVideoClick: PropTypes.func.isRequired,
  activeVideo: PropTypes.number.isRequired,
};

export default VideoSectionPlaylist;
